import { QuickbooksSettingsClient } from '@src/quickbooks/services/QuickbooksSettingsClient';
import { useQuery } from '@tanstack/react-query';

export const useQuickbooksStatus = () => {
  const { data, isLoading } = useQuery({
    queryKey: ['quickbooksStatus'],
    queryFn: QuickbooksSettingsClient.getStatus,
  });

  return {
    status: data,
    isLoading,
  };
};
